import { markup2Html, markup2markup } from '@api-consent/util/markup';
import { type MultiTextRenderOptions } from '@api-consent/model/MultiTextRenderOptions';

// Examples:
// (1) 'simple text'
// (2) [{ text: 'foo', langs: [], sps: [] }]
// (3) [{ text: 'foo', langs: ['de'], sps: [] }, { text: 'bar', langs: ['tr'], sps: [] }]

export interface MultiTextItem {
  text: string;
  langs?: string[];
  sps?: string[];
}

export type MultiTextSource = string | MultiTextItem[];

export default class MultiText {
  static render(source: MultiTextSource | undefined, {
    spId, lang, context = {}, textformat, fallbackText,
    textformatCompatibility: compatibility = false,
    includeCustomerAttributes = true,
    skipCompile = false,
  }: MultiTextRenderOptions) {
    if (source === undefined || source === null) return undefined;
    const data = typeof source === 'string' ? [{ text: source }] : source;
    // filter texts by service provider and/or language with fallback
    const text = data.find((item) => (
      (!item.langs?.length || (lang && item.langs?.includes(lang)))
      && (!item.sps?.length || (spId && item.sps?.includes(spId)))
    ))?.text ?? fallbackText;
    if (!text) return undefined; // no match found
    // pick the right textformat
    if (skipCompile) {
      return text;
    }
    const transpilerOptions = {
      context,
      compatibility,
      includeCustomerAttributes,
    };
    return textformat === 'html'
      ? markup2Html(text, transpilerOptions)
      : markup2markup(text, transpilerOptions);
  }

  static norm(text: MultiTextSource) {
    return typeof text === 'string' ? [{ text }] : text;
  }
}
